import { PAGE_KEY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { useState } from 'react';
const useReviewFilters = initialFilters => {
  const [filters, setFilters] = useState(initialFilters);
  const setReviewFilters = ({
    textKey,
    value
  }, trackInteraction) => {
    const filterUpdates = {
      [textKey]: value
    };
    let newFilters = filters.updateFilters(filterUpdates);
    if (!Object.prototype.hasOwnProperty.call(filterUpdates, PAGE_KEY)) {
      newFilters = newFilters.updateFilters({
        [PAGE_KEY]: 1
      });
    }
    setFilters(newFilters);
    if (trackInteraction) {
      trackInteraction(`change reviews ${textKey}`, {
        section: 'review',
        value
      });
    }
  };
  return {
    reviewFilters: filters,
    setReviewFilters
  };
};
export default useReviewFilters;